



































import {
  Component, Prop, Vue, PropSync, Watch,
} from 'vue-property-decorator';
import { value } from 'jsonpath';
@Component({
})
export default class PreviewTable extends Vue {
  @PropSync('avilableDays', {}) availableDay!: any;

  public partnerPreview: any = [
    {
      text: 'Restaurant 1',
      value: 1,
    },
    {
      text: 'Restaurant 2',
      value: 2,
    },
    {
      text: 'Restaurant 3',
      value: 3,
    },
    {
      text: 'Restaurant 4',
      value: 4,
    },
    {
      text: 'Restaurant 5',
      value: 5,
    },
  ]
}
